import { render, staticRenderFns } from "./StampCards.vue?vue&type=template&id=4faa10c4&scoped=true&"
import script from "./StampCards.vue?vue&type=script&lang=js&"
export * from "./StampCards.vue?vue&type=script&lang=js&"
import style0 from "./StampCards.vue?vue&type=style&index=0&id=4faa10c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa10c4",
  null
  
)

export default component.exports